export default __webpack_public_path__ + "static/media/main_level_test01_cn.bda9ca3e.png";